import React from "react";
import { Box } from "@chakra-ui/react";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";

function App() {
  return (
    <Box>
      <Navbar />
      <Box id="home" mt={20}> {/* Espaçamento para compensar a altura da Navbar */}
        <HeroSection />
      </Box>
      <Box id="sobre" position="relative" zIndex="1">
        <AboutSection />
      </Box>
      <Box id="serviços" py={10} bg="gray.50" position="relative" zIndex="1"> 
        <ServicesSection /> 
      </Box>
      <Box id="contato" py={10} bg="white" position="relative" zIndex="1"> 
        <ContactSection /> 
      </Box>
      <Footer />
      <WhatsAppFloat />
    </Box>
  );
}

export default App;
